<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-21 17:23:32
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row pl-12 pr-8" style="width: 240px">
		<div>
			<el-avatar shape="square" :size="40" :src="row.product_pic"></el-avatar>
		</div>
		<div class="ml-8">
			<div class="flex-row-align-center">
				<platform-icon :platformId="row.platform_id" class="flex-shrink"></platform-icon>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.product_name">
					<span class="ml-4 yx-color-text-primary font-h6-medium line-ellipsis-1 cursor-pointer hover" style="max-width: 140px" @click="skipFun">
						{{ row.product_name }}
					</span>
				</el-tooltip>
				<el-tooltip placement="top" :content="content" :disabled="$isSp(row.platform_id)">
					<div class="tag radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover" @click="copyLink()">
						<i class="el-icon-link"></i>
					</div>
				</el-tooltip>
				<ID-tag label="商品ID" :id="row.third_product_id" />
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center" v-if="row.tabName === '1'">
				<span>店铺：</span>
				<el-tooltip placement="top" v-ak-tooltip-auto-show :content="row.shop_name">
					<span style="max-width: 160px" class="line-ellipsis">{{ row.shop_name | formatEmpty }}</span>
				</el-tooltip>
				<ID-tag label="店铺ID" :id="row.shop_id" />
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center">
				<span>佣金率:</span>
				<span class="ml-2">{{ row.commission_rate }} %</span>
				<span class="ml-4">现售价:</span>
				<span class="ml-2">{{ row.sale_price | formatEmpty | formatPrice }}</span>
			</div>
			<div class="font-h6-regular yx-color-text-secondary flex-row-align-center" v-if="$auth.hasPermi('system:goods-ServiceRate')">
				<span>服务费率:</span>
				<span class="ml-2">{{ row.service_rate }} %</span>
			</div>
			<div class="mt-2 flex-row" style="flex-wrap: wrap">
				<plainTag type="primary">{{ row.product_type_name }}</plainTag>
				<plainTag type="warning" v-if="row.is_reissue == '1'">补发样品</plainTag>
				<plainTag type="primary" v-if="row.is_sync == 1">
					<span>已同步</span>
					<el-tooltip content="该合作进度已与商家账号同步，商家可协助进行寄样、确认带货、更换带货链接、校验链接、确认开播等操作" placement="top">
						<i class="el-icon-question font-h6-regular mt-2 ml-2 yx-color-text-placeholder"></i>
					</el-tooltip>
				</plainTag>
			</div>
		</div>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import plainTag from '@/components/ui/plainTag';
import { mapGetters } from 'vuex';
import { getSourceUrl } from '@/api/shopManage';
import { drRoleType } from '@/utils/dataMap';
import { copyFun } from '@/utils/common';
import IDTag from '@/components/ui/IDTag';
export default {
	components: {
		plainTag,
		IDTag,
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		...mapGetters(['isDarenPartner']),
		content() {
			// 保持不变
			return this.isDarenPartner
				? this.row.source_type === '2'
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
		drName() {
			return drRoleType.name;
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		async skipFun() {
			const {
				isDarenPartner,
				row: { product_id, cooperate_id, product_url },
				handLink,
			} = this;
			if (this.$isSp(this.row.platform_id)) {
				return;
			}
			// 保持不变
			if (isDarenPartner) {
				const { code, data } = await getSourceUrl({ product_id, cooperate_id });
				if (code === 0) {
					let link = data.pick_source;
					handLink(link);
				}
			} else {
				handLink(product_url);
			}
		},
		handLink(link) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
		copyLink() {
			copyFun(this.row, this, '1');
		},
	},
};
</script>
<style lang="less" scoped>
.tag {
	padding: 0 3px;
	border-radius: 3px;
	background-color: #f7f8fa;
	margin-left: 4px;
}
.reissue {
	width: 52px;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	background-color: #fef3e7;
	font-size: 12px;
	text-align: center;
}
</style>
